/* La Pepa · Mejor juntos (sections/lp-better-together.liquid, Kopie aus La Pepa US)
 * „Agregar los 3“ legt Produkt der Seite + 2 Partner über LpCart.add in den Warenkorb (Spinner, „Listo“, Bilder fliegen);
 * Partner tragen die versteckte Property _origen: mejor-juntos (Auswertung wie bei Complementa).
 * Beim Variantenwechsel des Hauptformulars (variant:change an product-form-<id>-…)
 * ziehen Varianten-ID, Preis, Bild und Variantenname der ersten Kachel nach, die Summe wird neu gerechnet.
 * Ausverkaufte oder nicht vorhandene Variante: Button deaktiviert.
 */
(() => {
  if (customElements.get('lp-better-together')) return;

  const WIDTHS = [180, 270, 360];
  const money = (cents) => (window.LpCart
    ? LpCart.money(cents)
    : `$${Math.round(cents / 100).toLocaleString('es-CO')}`);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const sized = (src, width) => {
    const url = new URL(src, location.href);
    url.searchParams.set('width', width);
    return url.toString();
  };

  customElements.define('lp-better-together', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-set-add]');
      this.main = this.querySelector('[data-set-main]');
      if (!this.button || !this.main) return;
      if (window.LpCart) LpCart.decorate(this.button);

      this.onClick = () => this.addAll();
      this.button.addEventListener('click', this.onClick);

      this.onVariantChange = (event) => {
        // getAttribute: form.id liefert das <input name="id">, nicht die ID des Formulars
        const id = (event.target && event.target.getAttribute && event.target.getAttribute('id')) || '';
        if (!id.startsWith(`product-form-${this.dataset.productId}-`)) return;
        this.setMainVariant(event.detail && event.detail.variant);
      };
      document.addEventListener('variant:change', this.onVariantChange);
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariantChange);
      if (this.button) this.button.removeEventListener('click', this.onClick);
    }

    items() {
      return [...this.querySelectorAll('[data-set-item]')];
    }

    setMainVariant(variant) {
      const m = this.main;
      if (!variant || !variant.id) {
        m.dataset.available = 'false';
        this.update();
        return;
      }
      m.dataset.variantId = variant.id;
      m.dataset.price = variant.price;
      m.dataset.compare = variant.compare_at_price || 0;
      m.dataset.available = String(!!variant.available);

      const price = m.querySelector('[data-set-price]');
      if (price) {
        const compare = Number(variant.compare_at_price || 0);
        price.innerHTML = money(variant.price) + (compare > variant.price
          ? ` <s><span class="sr-only">${esc(this.dataset.labelRegular || '')}</span>${money(compare)}</s>`
          : '');
      }

      const title = m.querySelector('[data-set-variant-title]');
      if (title && !title.hidden) title.textContent = variant.title || '';

      const src = (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src)
        || (variant.featured_image && variant.featured_image.src);
      const img = m.querySelector('.lp-set__img img');
      if (src && img) {
        img.srcset = WIDTHS.map((w) => `${sized(src, w)} ${w}w`).join(', ');
        img.src = sized(src, 360);
      }
      this.update();
    }

    update() {
      const items = this.items();
      let total = 0;
      let compare = 0;
      items.forEach((el) => {
        const price = Number(el.dataset.price || 0);
        total += price;
        compare += Math.max(Number(el.dataset.compare || 0), price);
      });
      const totalEl = this.querySelector('[data-set-total]');
      const compareEl = this.querySelector('[data-set-compare]');
      const compareValue = this.querySelector('[data-set-compare-value]');
      if (totalEl) totalEl.textContent = money(total);
      if (compareEl && compareValue) {
        compareValue.textContent = money(compare);
        compareEl.hidden = !(compare > total);
      }
      this.button.disabled = this.main.dataset.available !== 'true';
    }

    async addAll() {
      if (this.button.disabled) return;
      const body = this.items().map((el) => (el === this.main
        ? { id: Number(el.dataset.variantId), quantity: 1 }
        : { id: Number(el.dataset.variantId), quantity: 1, properties: { _origen: 'mejor-juntos' } }));
      const images = [...this.querySelectorAll('.lp-set__img img')];
      if (window.LpCart) {
        LpCart.add({ body, button: this.button, images }).catch(() => {});
        return;
      }
      // Ohne lp-cart.js: direkt hinzufügen, dann zur Warenkorbseite
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: body }),
        });
        if (res.ok) location.href = `${root}cart`;
      } catch (err) { /* Button bleibt bedienbar */ }
    }
  });
})();
